import _asyncToGenerator from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import clipboardCopy from 'clipboard-copy';
export default function useClipboardCopy() {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isCopied = _React$useState2[0],
    setIsCopied = _React$useState2[1];
  var timeout = React.useRef(undefined);
  React.useEffect(function () {
    return function () {
      clearTimeout(timeout.current);
    };
  }, []);
  var copy = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(text) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return clipboardCopy(text);
          case 2:
            setIsCopied(true);
            clearTimeout(timeout.current);
            timeout.current = setTimeout(function () {
              setIsCopied(false);
            }, 1200);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function copy(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    copy: copy,
    isCopied: isCopied
  };
}